export default {
  20503: '无接口权限',
};
